import React from "react";
import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { useLang } from "../LangContext";

const fade = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1], delay },
});

export default function FAQ() {
  const { t } = useLang();
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-y-12 md:gap-x-12">
          <div className="col-span-12 md:col-span-4">
            <motion.p {...fade(0)} className="eyebrow text-ink2">
              — {t.faq.eyebrow}
            </motion.p>
            <motion.h2
              {...fade(0.05)}
              className="headline mt-6 text-4xl sm:text-5xl lg:text-6xl text-ink"
              data-testid="faq-title"
            >
              {t.faq.title}
            </motion.h2>
          </div>
          <div className="col-span-12 md:col-span-7 md:col-start-6">
            <motion.div {...fade(0.1)}>
              <Accordion
                type="single"
                collapsible
                className="w-full"
                data-testid="faq-accordion"
              >
                {t.faq.items.map((item, i) => (
                  <AccordionItem
                    key={i}
                    value={`item-${i}`}
                    className="border-b border-line"
                    data-testid={`faq-item-${i}`}
                  >
                    <AccordionTrigger className="py-6 text-left hover:no-underline group">
                      <span className="font-serif text-xl md:text-2xl text-ink leading-snug pr-6">
                        {item.q}
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-6 text-base md:text-lg text-ink2 leading-relaxed">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
